export default __webpack_public_path__ + "static/media/video-tutorials.2af6eef9.svg";